// A synchronous in-process Messenger pair: `send` on one side delivers to the other side's subscribers
// within the SAME call stack. SyncSource's update tasks must be serialized AT emission time — a
// MessageChannel loopback defers by a macrotask, letting a later transaction delete boxes before the
// earlier batch resolves its primitive-field codecs against the live source graph.
import { Notifier, panic } from "@opendaw/lib-std";
export const createSyncLoopback = () => {
    const toTarget = new Notifier();
    const toSource = new Notifier();
    const port = (outgoing, incoming) => ({
        send: (message) => outgoing.notify(message),
        channel: () => panic("the sync loopback has no channels"),
        subscribe: (observer) => incoming.subscribe(observer),
        terminate: () => { }
    });
    return {
        source: port(toTarget, toSource),
        target: port(toSource, toTarget),
        terminate: () => {
            toTarget.terminate();
            toSource.terminate();
        }
    };
};
